import React, { Component } from 'react';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import * as firebase from 'firebase';

// pages
import Login from './pages/login/login';
import NewPassword from './pages/new-password/new-password';
import ForgotPassword from './pages/forgot-password/forgot-password';
import Home from './pages/home/home';
import AdminNewUser from './pages/admin/new-user/new-user';
import AdminEditUser from './pages/admin/edit-user/edit-user';
import AdminUpdateReport from './pages/admin/update-report/update-report';
import AdminNewReport from './pages/admin/new-report/new-report';
import NotFound from './pages/not-found/not-found';

// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyACBzT6Rt-hc7VgmmFQahMhRgxwHN7WxGI",
  authDomain: "tfs-external-pbi.firebaseapp.com",
  databaseURL: "https://tfs-external-pbi.firebaseio.com",
  projectId: "tfs-external-pbi",
  storageBucket: "tfs-external-pbi.appspot.com",
  messagingSenderId: "89890635301",
  appId: "1:89890635301:web:791c2757beb2f9d44209cc",
  measurementId: "G-B8NXVN9CQG"
};
firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    sessionStorage.setItem('uid', user.uid);
  } else {
    sessionStorage.clear();
  }
});

const createHistory = require("history").createBrowserHistory;
const history = createHistory()

// session for debugging
//sessionStorage.clear();
//sessionStorage.setItem('admin', 'true');
//sessionStorage.setItem('uid', '1');

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    sessionStorage.getItem('uid')
      ? <Component {...props} />
      : <Redirect to='/login' />
  )} />
)

const AdminRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    sessionStorage.getItem('admin')
      ? <Component {...props} />
      : <Redirect to='/home' />
  )} />
)

const LocalAdminRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    sessionStorage.getItem('local_admin') || sessionStorage.getItem('admin')
      ? <Component {...props} />
      : <Redirect to='/home' />
  )} />
)

if (window.location.pathname === '/') {
  if (sessionStorage.getItem('uid')) {
    window.location.replace('/home');
  } else {
    window.location.replace('/login');
  }
}

class App extends Component {

  render() {
    return (
      <Router history={history}>
        <div className="App">
            <Switch>
                <Route exact path="/login" component={Login} />
                <Route exact path="/forgot-password" component={ForgotPassword} />
                <PrivateRoute exact path="/new-password" component={NewPassword} />
                <PrivateRoute exact path="/home" component={Home} />
                <LocalAdminRoute exact path="/admin/new-user" component={AdminNewUser} />
                <AdminRoute exact path="/admin/new-user" component={AdminNewUser} />
                <AdminRoute exact path="/admin/edit-user" component={AdminEditUser} />
                <AdminRoute exact path="/admin/edit-report" component={AdminUpdateReport} />
                <AdminRoute exact path="/admin/new-report" component={AdminNewReport} />
                <Redirect from="*" to="/home" />
            </Switch>
        </div>
      </Router>
    );
  }
  
}

export default App;